export default __webpack_public_path__ + "static/media/background-popup1.cacc0b62.jpg";